// extracted by mini-css-extract-plugin
module.exports = {"toggle2":"Toggle_toggle2__2bsCF","toggle":"Toggle_toggle__17sD8","disabled":"Toggle_disabled__KwxVG","label":"Toggle_label__2KSW7"};